import { Alert, Col, Row } from 'antd';

const PaymentSuccess = () => {
  return (
    <div
      style={{
        width: '95%',
        margin: '0 auto',
      }}
    >
      <Row>
        <Col xs={12}>
          <Alert
            message="Payment Success"
            description="Your payment for tax return has been successful."
            type="success"
            showIcon
          />
        </Col>
      </Row>
    </div>
  );
};

export default PaymentSuccess;
